"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vitalPayloadToFormDataHandler = vitalPayloadToFormDataHandler;
const getVitalItemValue = (data, unit) => {
    if (!data) {
        return undefined;
    }
    return parseFloat(data.split(unit)[0].trim());
};
const getVitalItemValueAndUnit = (data) => {
    if (!data) {
        return {
            value: undefined,
            unit: undefined,
        };
    }
    const splitted = data.split(" ");
    return {
        value: parseFloat(splitted[0].trim()),
        unit: splitted[splitted.length === 2 ? 1 : 2].trim(),
    };
};
function vitalPayloadToFormDataHandler(data) {
    const weightData = getVitalItemValueAndUnit(data.form.weight);
    const bloodSugarData = getVitalItemValueAndUnit(data.form.bloodSugar);
    return {
        heartRate: getVitalItemValue(data.form.heartRate, "/minute"),
        bpSit: getVitalItemValue(data.form.bpSit, "mmHg"),
        bpStand: getVitalItemValue(data.form.bpStand, "mmHg"),
        repositoryRate: getVitalItemValue(data.form.repositoryRate, "/minute"),
        temperature: getVitalItemValue(data.form.temperature, "°F"),
        pulseOximetry: getVitalItemValue(data.form.pulseOximetry, "% O2 Sat"),
        pain: getVitalItemValue(data.form.pain, "out of 10"),
        weight: weightData.value,
        weightUnit: weightData.unit,
        bloodSugar: bloodSugarData.value,
        bloodSugarType: bloodSugarData.unit,
        location: data.form.location || "N/A",
        notes: data.form.notes || "",
    };
}
